import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { serviceWorkerFeature } from 'app/state/service-worker/service-worker.reducer';

import { ServiceWorkerEffects } from './service-worker.effects';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(serviceWorkerFeature), EffectsModule.forFeature([ServiceWorkerEffects])],
})
export class ServiceWorkerStateModule {}
